<div class="title" mat-dialog-title>Add Credentials</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your Rokt Account Manager to obtain the details below</div>
        <form [formGroup]="connectionForm" style="max-height: 360px;overflow: auto;">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>AccountId</mat-label>
                <input matInput placeholder="Enter AccountId" formControlName="accountId" data-cy="rokt-account-id-input">
                <mat-error
                    *ngIf="connectionForm.get('accountId').errors && (connectionForm.get('accountId').touched || connectionForm.get('accountId').dirty)">
                    Invalid AccountId</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>AppId</mat-label>
                <input matInput placeholder="Enter AppId" formControlName="appId" data-cy="rokt-app-id-input">
                <mat-error
                    *ngIf="connectionForm.get('appId').errors && (connectionForm.get('appId').touched || connectionForm.get('appId').dirty)">
                    Invalid AppId</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>App Secret</mat-label>
                <input type="password" matInput placeholder="Enter App Secret" formControlName="appSecret" data-cy="rokt-app-secret-input">
                <mat-error
                    *ngIf="connectionForm.get('appSecret').errors && (connectionForm.get('appSecret').touched || connectionForm.get('appSecret').dirty)">
                    Invalid App Secret</mat-error>
            </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="adobe-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>